/**
 * Xero item codes for things CatTrax sells that have no code of their own - inventory items, and the
 * frames, lenses and extras on a lens dispensing job.
 *
 * Each thing sold is its own Xero item, made by the server the first time an invoice carries a code
 * Xero doesn't have yet (named after the line's description). The code reads as what it is -
 * FRAME-RAY-BAN-RB5154-K2P9 - ending in a short tag from the product's own id, so two products with one
 * name never share an item and a renamed one keeps its sales history. Xero allows 30 characters.
 *
 * The codes must not change once in use: a different code for the same product makes a second Xero item.
 */
app.service("XeroItemCode", [
	function () {
		const ITEM_CODE_LENGTH = 30;
		const slug = (s) => String(s || "").toUpperCase().replace(/[^A-Z0-9]+/g, "-").replace(/^-+|-+$/g, "");

		function idTag(id) {
			let h = 5381;
			const str = String(id);
			for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
			return ("0000" + h.toString(36).toUpperCase()).slice(-4);
		}

		// An inventory item's code starts with its category. FRAME matches the frame lines lens dispensing
		// raises, so a frame sold either way is the one Xero item.
		const INVENTORY_PREFIXES = {
			FRAME: "FRAME",
			SUNGLASSES: "SUN",
			CONTACT_LENSES: "CL",
			READING_GLASSES: "READERS",
			EYE_DROPS: "DROPS",
			ACCESSORIES: "ACC",
			INTRAOCULAR_LENSES: "IOL",
			INJECTABLES: "INJ",
			MEDICATIONS: "MED",
			SURGICAL_CONSUMABLES: "SURG",
			SURGICAL_INSTRUMENTS: "INSTR",
			DIAGNOSTIC_SUPPLIES: "DIAG",
			SUNDRY: "SUNDRY",
			OTHER: "INV",
		};

		const service = {
			/**
			 * @param {string} prefix - What kind of thing it is, e.g. "FRAME".
			 * @param {string} name - Its name, shortened to fit.
			 * @param {string} [id] - Its own id, for the tag that keeps the code unique.
			 */
			make: function (prefix, name, id) {
				const tag = id ? idTag(id) : "";
				const room = ITEM_CODE_LENGTH - prefix.length - 1 - (tag ? tag.length + 1 : 0);
				const body = slug(name).slice(0, room).replace(/-+$/, "");
				return [prefix, body, tag].filter(Boolean).join("-");
			},

			/** The code an InventoryAPI item is invoiced under. */
			forInventoryItem: function (item) {
				return service.make(INVENTORY_PREFIXES[item.category] || "INV", item.name, item.item_id);
			},
		};

		return service;
	},
]);
